import { createApp } from 'vue'
import { createPinia } from 'pinia'

import PartnerQualityFeedbackForm from '@/src/javascripts/partner/quality_feedbacks/PartnerQualityFeedbackForm.vue'
import BaseAlert from '@/src/vueComponent/BaseAlert.vue'

$(document).on('turbo:load turbo:render', () => {
  const partnerQualityFeedbackForm = document.querySelector('#partner-quality-feedback-form')

  if (partnerQualityFeedbackForm && !partnerQualityFeedbackForm.__vue_app__) {
    const pinia = createPinia()
    const app = createApp({
      components: { PartnerQualityFeedbackForm, BaseAlert }
    })

    app.use(pinia)
    app.mount(partnerQualityFeedbackForm)
  }
})
